import { AUTH_ROUTE_NAME } from "@/libs/route-name";

export const authRoute = () => {
    return {
        name: AUTH_ROUTE_NAME.AUTH,
        path: "",
        component: () => import("@/pages/auth/index.vue"),
        redirect: { name: AUTH_ROUTE_NAME.SIGNIN },
    }
}